import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import standardToPremiumModalParameters from '@atlassian/jira-relay/src/__generated__/ui_JsmStandardToPremiumModalQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	productKey: string;
};
export const servicedeskStandardToPremiumModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-standard-to-premium-modal" */ './src/ui'),
	),
	getPreloadProps: ({ cloudId, productKey }: EntryPointParams) => ({
		queries: {
			standardToPremiumModal: {
				parameters: standardToPremiumModalParameters,
				variables: { cloudId, productKey, isCollectionEnabled: fg('servco-xflow-ga') },
			},
		},
	}),
});
